/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2019, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
*/

import {
  Component, EventEmitter, Input, Output,
} from '@angular/core';

@Component({
  selector: 'aero-tags',
  templateUrl: './aero-tags.component.html',
  styleUrls: ['./aero-tags.component.scss'],
  standalone: false,
})
export class AeroTagsComponent {

  @Input() name!: string;

  @Input() description?: string;

  @Input() maxUses?: number;

  @Input() color? = '#00AEEF';

  @Input() showCross = false;

  @Input() faded = false;

  @Output() crossClicked = new EventEmitter<boolean>();

  onCrossClick(event: MouseEvent) {
    event.stopPropagation();
    this.crossClicked.emit(true);
  }

  get tooltip(): string {
    const parts: string[] = [];
    if (this.description) {
      parts.push(this.description);
    }
    if (this.maxUses != null) {
      parts.push(`Max uses: ${this.maxUses}`);
    }
    return parts.join(' | ');
  }
}
